import {Text} from '@rdcomponents/text/text';
import {Button, Tooltip} from 'antd';
import {useState} from 'react';

import {Locale} from '../../../../provider/locale/locale';
import {useLocale} from '../../../../provider/locale/locale-hook';
import {SkippedCompanyType} from '../../../../service/company/company-type';
import {classNames} from '../../../../util/css';
import {getPlural} from '../../../../util/plural';

import {VISIBLE_SKIPPED_COMPANIES_COUNT} from './skipped-companies-alert-const';
import * as styles from './skipped-companies-alert.scss';

type PropsType = {
    companies: Array<SkippedCompanyType>;
};

export function SkippedCompaniesList(props: PropsType): JSX.Element {
    const {companies} = props;
    const {localeName} = useLocale();
    const [isExpanded, setIsExpanded] = useState<boolean>(false);

    const visibleCompanies = isExpanded ? companies : companies.slice(0, VISIBLE_SKIPPED_COMPANIES_COUNT);
    const hiddenCount = companies.length - visibleCompanies.length;

    const hiddenCountText = getPlural<JSX.Element>({
        count: hiddenCount,
        localeName,
        singular: (
            <Locale stringKey="BULK_EDIT_COMPANIES__VIDEO_SKIPPED__MORE__SINGULAR" valueMap={{count: hiddenCount}} />
        ),
        pluralFew: <Locale stringKey="BULK_EDIT_COMPANIES__VIDEO_SKIPPED__MORE__FEW" valueMap={{count: hiddenCount}} />,
        pluralMany: (
            <Locale stringKey="BULK_EDIT_COMPANIES__VIDEO_SKIPPED__MORE__MANY" valueMap={{count: hiddenCount}} />
        ),
    });

    return (
        <>
            <ul className={styles.SkippedCompaniesAlert_list}>
                {visibleCompanies.map((company) => (
                    <li key={company.companyId}>
                        {company.companyName}
                        {(company.companyAddress || company.companyCode) && ', '}
                        <Text secondary>
                            {company.companyAddress}
                            {company.companyAddress && company.companyCode && ', '}
                            {company.companyCode && (
                                <Tooltip title={<Locale stringKey="REVIEWS__REVIEW__COMPANY_CODE__HINT" />}>
                                    <span>{company.companyCode}</span>
                                </Tooltip>
                            )}
                        </Text>
                    </li>
                ))}

                {hiddenCount > 0 && (
                    <li>
                        {hiddenCountText}
                        <Button
                            className={classNames(
                                styles.SkippedCompaniesAlert_toggle,
                                styles.SkippedCompaniesAlert_showAll
                            )}
                            onClick={() => setIsExpanded(true)}
                            size="small"
                            type="link"
                        >
                            <Locale stringKey="BULK_EDIT_COMPANIES__VIDEO_SKIPPED__SHOW_ALL" />
                        </Button>
                    </li>
                )}
            </ul>

            {isExpanded && (
                <Button
                    className={styles.SkippedCompaniesAlert_toggle}
                    onClick={() => setIsExpanded(false)}
                    size="small"
                    type="link"
                >
                    <Locale stringKey="BULK_EDIT_COMPANIES__VIDEO_SKIPPED__COLLAPSE" />
                </Button>
            )}
        </>
    );
}
